/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./deleteTarget.defs.js";
export { main as default } from "./deleteTarget.defs.js";
